
export const GLOBAL_NAMESPACE = 'teamerp.';
export const AUTHORIZATION = GLOBAL_NAMESPACE + 'authorization';
export const REMEMBER_USERNAME = GLOBAL_NAMESPACE + 'username';
export const REMEMBER_PASSWORD = GLOBAL_NAMESPACE + 'password';
export const REMEMBER_TAG = GLOBAL_NAMESPACE + 'remember';
export const PROJECT_UUID = GLOBAL_NAMESPACE + 'project_uuid';
export const PROJECT_NAME = GLOBAL_NAMESPACE + 'project_name';

export const USER_ID = GLOBAL_NAMESPACE + 'user_id';
export const USER_UUID = GLOBAL_NAMESPACE + 'user_uuid';
export const USER_NAME = GLOBAL_NAMESPACE + 'user_name';
export const USER_PROJECT_ID = GLOBAL_NAMESPACE + 'user_project_id';
export const USER_META = GLOBAL_NAMESPACE + 'user_meta';
export const USER_MOBILE = GLOBAL_NAMESPACE + 'user_mobile';
export const AVATAR = GLOBAL_NAMESPACE + 'avatar';
export const AUTHORITY = GLOBAL_NAMESPACE + 'authority';
export const CURRENT_URL = GLOBAL_NAMESPACE + 'current_url';
// 记录每个项目最后打开的页面路由
export const PROJECT_URLS = GLOBAL_NAMESPACE + 'project_url';
// 记录最后打开的url
export const LAST_URL = GLOBAL_NAMESPACE + 'last_url';

// export const SELECTED_PANEL = GLOBAL_NAMESPACE + 'selected_panel';
// export const SELECTED_MAJOR = GLOBAL_NAMESPACE + 'selected_major';

export const SELECT_PROJECT_ID = GLOBAL_NAMESPACE + 'select_project_id';

class LocalStore {

    public get(key: string) {
        let item = localStorage.getItem(key);
        if (item == "undefined") {
            return null;
        }
        return JSON.parse(localStorage.getItem(key) || 'null') || null;
    }

    public set(key: string, value: any) {
        localStorage.setItem(key, JSON.stringify(value));
    }

    public remove(key: string): void {
        localStorage.removeItem(key);
    }

    get token(): string {
        return this.get(AUTHORIZATION) || '';
    }

    set token(value: string) {
        this.set(AUTHORIZATION, value);
    }

    get userId(): number {
        return +this.get(USER_ID) || null;
    }
    set userId(value: number) {
        this.set(USER_ID, value);
    }
    get userUuid(): string {
        return this.get(USER_UUID) || null;
    }
    set userUuid(value: string) {
        this.set(USER_UUID, value);
    }

    get userProjectId(): number {
        return +this.get(USER_PROJECT_ID) || null;
    }
    set userProjectId(value: number) {
        this.set(USER_PROJECT_ID, value);
    }

    get lastUrl(): string {
        return this.get(LAST_URL) || null;
    }

    set lastUrl(value: string) {
        this.set(LAST_URL, value);
    }

    get name(): string {
        return this.get(USER_NAME) || '';
    }
    set name(value: string) {
        this.set(USER_NAME, value);
    }

    get mobile(): string {
        return this.get(USER_MOBILE) || '';
    }
    set mobile(value: string) {
        this.set(USER_MOBILE, value);
    }

    get password(): string {
        return this.get(REMEMBER_PASSWORD) || '';
    }
    set password(value: string) {
        this.set(REMEMBER_PASSWORD, value);
    }

    get projectUuid(): string {
        return this.get(PROJECT_UUID) || '';
    }
    set projectUuid(value: string) {
        this.set(PROJECT_UUID, value);
    }

    get projectName(): string {
        return this.get(PROJECT_NAME) || '';
    }
    set projectName(value: string) {
        this.set(PROJECT_NAME, value);
    }

    get currentUrl(): string {
        return this.get(CURRENT_URL) || '';
    }
    set currentUrl(value: string) {
        this.set(CURRENT_URL, value);
    }
    get projectUrls() {
        return this.get(PROJECT_URLS)
    }

    set projectUrls(value: { [key: number]: string }) {
        this.set(PROJECT_URLS, value)
    }

    get selectProjectId(){
        return this.get(SELECT_PROJECT_ID) || null;
    }

    set selectProjectId(value: number){
        this.set(SELECT_PROJECT_ID, value);
    }


    public setAuthority(types: number[]) {
        if (types == null) {
            this.remove(AUTHORITY);
            return;
        }
        this.set(AUTHORITY, types);
    }

    public getAuthority() {
        return this.get(AUTHORITY);
    }

    public getUser() {
        return this.get(USER_META);
    }

    // 根据projectId获得上次打开的页面
    public getLastUrlByProject(projectId: number) {
        const projectUrls = this.get(PROJECT_URLS);
        if (projectUrls == null) return null;
        const url = projectUrls[projectId];
        return url;
    }

    // 设置projectId上次打开的页面
    public setLastUrl(projectId: number, url: string) {
        let projectUrls = this.get(PROJECT_URLS);
        if (projectUrls == null) {
            projectUrls = {};
            projectUrls[projectId] = url;
        } else {
            projectUrls[projectId] = url;
        }
        return this.set(PROJECT_URLS, projectUrls);
    }

    clearProjectInfo() {
        // this.remove(AUTHORITY);
        this.remove(PROJECT_UUID);
        this.remove(PROJECT_NAME);
    }

    clear() {
        this.remove(AUTHORIZATION);
        this.remove(PROJECT_UUID);
        this.remove(PROJECT_NAME);
        this.remove(USER_ID);
        this.remove(USER_NAME);
        this.remove(USER_META);
        this.remove(AUTHORITY);
        this.remove(USER_PROJECT_ID);
        this.remove(PROJECT_URLS);
        this.remove(LAST_URL);
    }
}

export default new LocalStore();